import { render, staticRenderFns } from "./PermisosCategoria.vue?vue&type=template&id=78eb9933&scoped=true"
import script from "./PermisosCategoria.vue?vue&type=script&lang=js"
export * from "./PermisosCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eb9933",
  null
  
)

export default component.exports